export function shorterNumber(n: number): string {
    let coins = n;
    let k = '';
    while (coins > 10000) {
        coins /= 1000;
        k += 'k';
    }

    return Math.floor(coins) + k;
}

export function thousandSpacing(n: number):string {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}